@import 'variables';

// -----

$-shadow: 0 0 4px 1px rgba(16, 29, 48, 20%);
$-shadow-transition: box-shadow 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

// -----

:host {
  overflow: hidden;
  position: relative;
  display: flex;
}

:host([hidden]) {
  display: none;
}

// ----- Scroll shadows

%shadow {
  position: absolute;
  transition: $-shadow-transition;
}

.shadow-top {
  @extend %shadow;
  z-index: 2;
  width: 100%;
  top: 0;
}

.shadow-left {
  @extend %shadow;
  z-index: 4;
  height: 100%;
  left: 0;
}

.shadow-right {
  @extend %shadow;
  z-index: 4;
  height: 100%;
  right: 0;
}

.shadow-bottom {
  @extend %shadow;
  z-index: 2;
  width: 100%;
  bottom: 0;
}

// ----- Component

.scrollable-wrapper {
  position: absolute;
  inset: 0;
  pointer-events: none;

  &.cat-scrollable-top .shadow-top,
  &.cat-scrollable-bottom .shadow-bottom,
  &.cat-scrollable-left .shadow-left,
  &.cat-scrollable-right .shadow-right {
    box-shadow: $-shadow;
  }
}

.scrollable-content {
  width: 100%;
  overflow: hidden;
  // white-space: nowrap;
  scrollbar-gutter: var(--cat-scrollbar-gutter, auto);
  scrollbar-color: var(--cat-scrollbar-color, auto);

  &.scroll-x {
    overflow-x: auto;
  }

  &.scroll-y {
    overflow-y: auto;
  }

  &.no-overscroll {
    overscroll-behavior: contain;
  }
}
